import React, { useEffect, useState } from "react";
import Sidebar from "../components/Sidebar";
import Header from "../components/Header";
import { Link } from "react-router-dom";
import api from "../Api";
import { IMAGE_URL } from "../utils/constants";

const ReportSelectGame = () => {
  const [QuizReportCount, setQuizReportCount] = useState(0);
  const [OneWordReportCount, setOneWordReportCount] = useState(0);
  const [CalculationReportCount, setCalculationReportCount] = useState(0);
  const [BlackboxReportCount, setBlackboxReportCount] = useState(0);
  const [EncyclopaediaCount, setEncylopediaCount] = useState(0);
  const [ImageCount, setImageCount] = useState(0);
  const [TriviaCount, setTriviaCount] = useState(0);

  const games = [
    {
      id: 1,
      name: "Calculation",
      icon: IMAGE_URL + "Calculation.png",
      path: "calculation",
      description: "Review calculation game reports",
      report_count: CalculationReportCount,
    },
    {
      id: 2,
      name: "One Word",
      icon: IMAGE_URL + "Oneword.png",
      path: "one-word",
      description: "Review one word game reports",
      report_count: OneWordReportCount,
    },
    {
      id: 3,
      name: "Quiz",
      icon: IMAGE_URL + "Quiz_icon.png",
      path: "quiz",
      description: "Review quiz game reports",
      report_count: QuizReportCount,
    },
    {
      id: 4,
      name: "Blackbox",
      icon: IMAGE_URL + "Blackbox.png",
      path: "blackbox",
      description: "Review blackbox game reports",
      report_count: BlackboxReportCount,
    },
    {
      id: 5,
      name: "Citius. Altius. Longius.",
      icon: IMAGE_URL + "avio-placeholder.svg",
      path: "encyclopaedia",
      description: "Review Encyclopedia game reports",
      report_count: EncyclopaediaCount,
    },
    {
      id: 6,
      name: "Plane Spotter",
      icon: IMAGE_URL + "avio-placeholder.svg",
      path: "image-game",
      description: "Review Plane Spotter game reports",
      report_count: ImageCount,
    },
    {
      id: 7,
      name: "Jetting Around The World",
      icon: IMAGE_URL + "avio-placeholder.svg",
      path: "trivia",
      description: "Review Trivia game reports",
      report_count: TriviaCount,
    },
  ];

  // Total reports from all games
  const totalReportCount =
    QuizReportCount +
    OneWordReportCount +
    CalculationReportCount +
    BlackboxReportCount +
    EncyclopaediaCount +
    ImageCount +
    TriviaCount;

  // Get counts for reports
  useEffect(() => {
    const endpoints = [
      {
        url: "/quiz/admin/check-report-unsolved",
        setter: setQuizReportCount,
      },
      {
        url: "/one-word/admin/check-report-unsolved",
        setter: setOneWordReportCount,
      },
      {
        url: "/calculation/admin/check-report-unsolved",
        setter: setCalculationReportCount,
      },
      {
        url: "/blackbox/admin/check-report-unsolved",
        setter: setBlackboxReportCount,
      },
      {
        url: "/encyclopaedia/admin/check-report-unsolved",
        setter: setEncylopediaCount,
      },
      {
        url: "/image-game/admin/check-report-unsolved",
        setter: setImageCount,
      },
      {
        url: "/trivia/admin/check-report-unsolved",
        setter: setTriviaCount,
      },
    ];

    const fetchAllCounts = async () => {
      try {
        const responses = await Promise.all(
          endpoints.map(({ url }) =>
            api.get(url).catch((error) => {
              console.error(
                `Error fetching ${url}:`,
                error.message
              );
              return null;
            })
          )
        );

        responses.forEach((response, index) => {
          if (response?.data?.count !== undefined) {
            endpoints[index].setter(response.data.count);
          }
        });
      } catch (error) {
        console.error(
          "Error fetching counts:",
          error.message
        );
      }
    };

    fetchAllCounts();

    // Refresh all counts every 30 seconds
    const interval = setInterval(fetchAllCounts, 30000);

    return () => clearInterval(interval);
  }, []);

  return (
    <>
      <Sidebar />

      <div className="main-wrapper">
        <Header />

        <div className="content-wrapper">
          <section className="main-section spacer-y">
            <div className="container">
              <div className="row gy-4">
                <div className="col-xl-12">

                  {/* Page Header */}
                  <div className="common_main_bg_wrapper">
                    <div className="common_main_heading_wrapper">
                      <div className="vstack">
                        <h1 className="mb-2 mt-3">
                          Report Management
                        </h1>

                        <p className="text-white mb-1">
                          Select a game to view and manage reports
                        </p>
                      </div>
                    </div>
                  </div>

                  {/* Games Section */}
                  <div className="common-table-wrapper mt-4">

                    {/* Section Header */}
                    <div className="common-table-filter-wrapper">
                      <div
                        className="common-left-blk"
                        style={{
                          width: "100%",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                          gap: "20px",
                        }}
                      >

                        {/* Heading */}
                        <div className="common_sub_heading_wrapper mb-0">
                          <h2>Select Game</h2>
                        </div>

                        {/* Total Reports */}
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "10px",
                            padding: "6px 14px",
                            border: "1px solid #e5e5e5",
                            borderRadius: "8px",
                            backgroundColor: "#fff",
                            boxShadow:
                              "0 2px 6px rgba(0,0,0,0.04)",
                          }}
                        >
                          <span
                            style={{
                              fontSize: "14px",
                              color: "#666",
                              fontWeight: "500",
                            }}
                          >
                            Total Reports
                          </span>

                          <span
                            style={{
                              minWidth: "32px",
                              height: "28px",
                              padding: "0 9px",
                              display: "inline-flex",
                              alignItems: "center",
                              justifyContent: "center",
                              borderRadius: "14px",
                              backgroundColor: "#ff6b6b",
                              color: "#fff",
                              fontSize: "13px",
                              fontWeight: "700",
                              lineHeight: "1",
                            }}
                          >
                            {totalReportCount}
                          </span>
                        </div>
                      </div>
                    </div>

                    {/* Game Cards */}
                    <div className="common_content_blk">
                      <div className="row row-cols-1 row-cols-sm-2 row-cols-md-3 row-cols-xl-4 g-4">

                        {games.map((game) => (
                          <div
                            className="col"
                            key={game.id}
                          >
                            <Link
                              to={`/report/${game.path}`}
                              className="quiz_card_wrapper"
                              style={{
                                textDecoration: "none",
                              }}
                            >
                              <div
                                className="vstack align-items-center gap-3"
                              >
                                {/* Icon */}
                                <div className="level_icon">
                                  <img
                                    src={game.icon}
                                    alt={game.name}
                                  />
                                </div>

                                {/* Game Information */}
                                <div className="flex-grow-1 text-center">

                                  <h3 className="mb-1">
                                    {game.name}

                                    {game.report_count > 0 && (
                                      <span
                                        style={{
                                          backgroundColor:
                                            "#ff6b6b",
                                          color: "#fff",
                                          borderRadius: "12px",
                                          padding: "4px 9px",
                                          fontSize: "12px",
                                          fontWeight: "700",
                                          marginLeft: "8px",
                                          display:
                                            "inline-flex",
                                          alignItems:
                                            "center",
                                          justifyContent:
                                            "center",
                                          minWidth: "24px",
                                          height: "22px",
                                          lineHeight: "1",
                                          verticalAlign:
                                            "middle",
                                        }}
                                      >
                                        {game.report_count}
                                      </span>
                                    )}
                                  </h3>

                                  <p className="mb-0 text-muted">
                                    {game.description}
                                  </p>
                                </div>
                              </div>
                            </Link>
                          </div>
                        ))}

                      </div>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </>
  );
};

export default ReportSelectGame;